export class PrescriptionDataModel {
    DoctorName: string;   
    PrescriptionNo: string;
    PrescriptionDate: string;  
    PrescriptionsSubData: PrescriptionViewModel[];  
}
export class PrescriptionViewModel {   
    Usages: string;
    DrugName: string;
    Dosage: string;  
    Frequency: string;   
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/prescription/prescriptiondatamodel.ts